import { rgba } from 'polished';
import { PropsWithChildren } from 'react';
import { Box } from 'reflexbox';
import styled from 'styled-components';
import VoiceMemoButton from './VoiceMemoButton';

import VoiceMemoCountdown from './VoiceMemoCountdown';

const Container = styled(Box)<{ active?: boolean; recording?: boolean }>`
	width: 32px;
	height: 32px;
	border-radius: 16px;
	transition: 1s cubic-bezier(0, 1, 0, 1) all;
	transform: translateX(-40px);

	${(props) =>
		props.active
			? `
    background: ${rgba(
			props.recording ? props.theme.colors.danger : props.theme.colors.primary,
			0.1,
		)};
    transform: none;
    width: 100%;
    height: 100%;
    border-radius: 8px;
`
			: props.recording &&
			  `
        background: ${props.theme.colors.danger};
`}
`;

export default function VoiceMemoTransition(
	props: PropsWithChildren<{
		status: 'collapsed' | 'loading' | 'countdown' | 'expanded';
	}>,
) {
	return (
		<Container active={props.status === 'expanded'}>
			{props.status === 'expanded' ? (
				props.children
			) : props.status === 'countdown' ? (
				<VoiceMemoCountdown />
			) : (
				<VoiceMemoButton loading={props.status === 'loading'} />
			)}
		</Container>
	);
}
